// Task text fields (US 9390, with lists since US 9394) are read with the rich text helpers
import { richTextToPlainText } from '@/components/richText/richText';

// Stored note -> text without formatting, e.g. to decide whether a preview needs shortening
export function noteToPlainText(note) {
  return richTextToPlainText(note, { headings: false, compact: true });
}
